module.exports = __webpack_public_path__ + "img/Abnormal_OVERTEMP.0a031467.png";